import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccountService } from '../../../accounts/accountService';
import { BotsService } from './bots.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Severity } from '../constants/integration.constant';
import { TitleCasePipe } from '@angular/common';
import {
  lastValueFrom,
  Subject,
} from 'rxjs';
import { WhatsAppService } from '../../../misc/campaign/services/whatsapp.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bots',
  templateUrl: './bots.component.html',
  styleUrls: ['./bots.component.scss'],
  providers: [WhatsAppService],
})
export class BotsComponent implements OnInit, OnDestroy {
  isSMSshowInstall: boolean;
  isSMSshowInstalled: boolean;
  isSMSshowDetail: boolean;
  isSMS = false;
  isWhtasappshowInstall = true;
  isWhtasappshowInstalled = false;
  isWhtasappshowDetail = false;
  isWhatsapp = false;

  products = [];
  displayMoreInfo = false;
  fullInfo;
  temp;
  dataView = true;

  displayBuyNumber = false;
  countries = [];
  // selectedCountry;
  critiria = [
    { id: 1, name: 'Number' },
    { id: 2, name: 'Locality' },
  ];
  matchTo = [
    { id: 0, name: 'First part of number' },
    { id: 1, name: 'Anywhere in number' },
    { id: 2, name: 'Last part of number' },
  ];

  allNumbers = [];
  activeNumbers = [];
  tempNumber;

  displayMessageLog = false;
  messages = [];
  phoneNumberPurchaseForm: FormGroup;
  organisationId: number;
  registeredData: any;

  //whatsapp
  cols = [
    { header: 'Name', field: 'name', isChecked: true },
    { header: 'Category', field: 'category', isChecked: true },
    { header: 'Phone No.', field: 'phone', isChecked: true },
    { header: 'Timezone', field: 'timezone', isChecked: true },
    { header: 'Is Active', field: 'isActive', isChecked: true },
    { header: 'Is Default', field: 'isDefault', isChecked: true },
  ];
  members: any = [
    {
      id: 1,
      name: 'Jenny Wilson',
      timezone: '(GMT-04:00) America/New York',
      isDefault: true,
      isActive: true,
      category: 'Automotive',
      phone: 2403839999,
      description: '',
    },
    {
      id: 2,
      name: 'Kathryn Murphy',
      timezone: '(GMT-04:00) America/New York',
      isDefault: false,
      isActive: true,
      category: 'Beauty, Spa and Salon',
      phone: 2403839999,
      description: '',
    },
  ];
  selectedProduct;
  isView = false;
  displayAddPhone = false;

  //registration
  displayRegistration = false;

  whatsAppBusinessAccounts: any[] = [];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  assestBaseUrl: string = environment.assestsBasePath;

  constructor(
    private confirmationService: ConfirmationService,
    private accountService: AccountService,
    private botsService: BotsService,
    private app: AppMainComponent,
    private appMainService: AppMainService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private titlecasePipe: TitleCasePipe,
    private whatsAppService: WhatsAppService
  ) {
    this.createPhonePurchaseForm();
  }

  ngOnInit() {
    this.checkInstalled();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  async checkInstalled() {
    // check WhatsApp installed
    await this.checkWhatsAppInstalled();
    this.products = [
      {
        id: 2,
        name: 'WhatsApp',
        img: 'whatsapp.jpg',
        description: 'Send WhatsApp',
        showInstall: this.isWhtasappshowInstall,
        showSpin: false,
        showInstalled: this.isWhtasappshowInstalled,
        showDetail: this.isWhtasappshowDetail,
      },
    ];
  }

  installBtn(c) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (c.id == 1) {
          if (this.registeredData?.authToken == null) {
            this.botsService
              .createSubAccount(this.app.companyId)
              .then((result) => {
                console.log(result);
                if (result) {
                  let body = {
                    id: 0,
                    sid: result.accountSid,
                    authToken: result.authToken,
                    smsNumber: '',
                    countryCode: '',
                    statusId: 1,
                  };
                  this.botsService.registerTwilio(body).then((data) => {
                    this.isSMSshowInstalled = true;
                    this.isSMSshowDetail = true;
                    this.isSMSshowInstall = false;
                    // console.log(data)
                  });
                }
              });
          } else if (
            this.registeredData?.authToken &&
            this.registeredData?.statusId == 0
          ) {
            this.activateSubAccount(c);
          }
        } else if (c.id == 2) {
          this.installUninstallWhatsApp(c);
        }
      },
    });
  }

  async installUninstallWhatsApp(c) {
    try {
      c.showSpin = true;
      await lastValueFrom(this.whatsAppService.alterWhatsAppSubscription());
      const res = await lastValueFrom(
        this.whatsAppService.getWhatsAppSubscription()
      );
      if (res) {
        c.showSpin = false;
        c.showInstall = !res.subscribed;
        c.showInstalled = res.subscribed;
        c.showDetail = res.subscribed;
      }
    } catch (error) {
      c.showSpin = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to install WhatsApp',
      });
    }
  }

  async checkWhatsAppInstalled() {
    try {
      const res = await lastValueFrom(
        this.whatsAppService.getWhatsAppSubscription()
      );
      if (res) {
        this.isWhtasappshowInstall = !res.subscribed;
        this.isWhtasappshowInstalled = res.subscribed;
        this.isWhtasappshowDetail = res.subscribed;
      }
    } catch {}
  }

  uninstallBtn(c) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (c.id === 1) {
          this.deactivateSubAccount(c);
        } else if (c.id === 2) {
          this.installUninstallWhatsApp(c);
        }
      },
    });
  }

  changeTableView(c) {
    if (c.id == 1) {
      this.getActiveNumbers();
      this.temp = JSON.parse(JSON.stringify(c));
      this.dataView = false;
      this.isSMS = true;
      this.isWhatsapp = false;
    } else if (c.id == 2) {
      this.dataView = false;
      this.isSMS = false;
      this.isWhatsapp = true;
    }
  }

  getActiveNumbers(isShowLoader = true) {
    isShowLoader && this.appMainService.isShowSpinner('getActiveNumbers');
    this.botsService.getActiveNumbers(this.app.companyId).subscribe({
      next: (numbers) => {
        for (let n of numbers) {
          n.status = 'Pending Registration';
        }
        this.activeNumbers = numbers;
        isShowLoader && this.appMainService.isHideSpinner('getActiveNumbers');
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
  }

  backDataView() {
    this.dataView = true;
  }

  showMoreInfo(c) {
    this.fullInfo = JSON.parse(JSON.stringify(c));
    this.displayMoreInfo = true;
  }

  buyNumber(isShowLoader = true) {
    isShowLoader && this.appMainService.isShowSpinner('getCountries');
    this.botsService.getAllCountries(this.app.companyId).subscribe({
      next: (countries) => {
        isShowLoader && this.appMainService.isHideSpinner('getCountries');
        this.countries = countries;
        this.countries = this.countries.map((divition: any) => {
          return {
            ...divition,
            displayLabel:
              '(+' +
              divition?.countryCode +
              ')' +
              ' ' +
              divition?.country +
              '-' +
              divition?.isoCountryCode,
          };
        });
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
    this.displayBuyNumber = true; // check after
    this.clear();
  }

  openMessageLog(data) {
    this.botsService
      .getMessageLogs(this.app.companyId, data.phoneNumber)
      .subscribe({
        next: (logs) => {
          this.messages = logs;
        },
      });
    this.displayMessageLog = true;
  }

  confirmRelease(data) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to release this phone number?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.tempNumber = JSON.parse(JSON.stringify(data));
        this.realeasePhoneNumber(data);
        this.tempNumber.isActive = false;
        let arr = [];
        for (let s of this.activeNumbers) {
          if (s.id == this.tempNumber.id) {
            arr.push(this.tempNumber);
          } else {
            arr.push(s);
          }
        }
        this.activeNumbers = JSON.parse(JSON.stringify(arr));
      },
    });
  }

  // -------------------------------my work-----------------------

  realeasePhoneNumber(item) {
    1;
    let requestBody: {
      organizationId: number;
      phoneNumber: string;
    } = {
      organizationId: this.app.companyId,
      phoneNumber: encodeURIComponent(item?.phoneNumber),
    };
    this.botsService.realeasePhoneNumber(requestBody).subscribe({
      next: (data) => {
        // console.log(data);
        if (data) {
          this.getActiveNumbers();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
  }

  createPhonePurchaseForm() {
    this.phoneNumberPurchaseForm = this.fb.group({
      selectedCountry: [null],
      SearcByNumberOrPhrase: [null],
      SearchCriteria: [null],
      MatchTo: [null],
    });
  }

  searchNumber(isShowLoader = true) {
    isShowLoader && this.appMainService.isShowSpinner('searchNumber');
    let requestBody: {
      SearcByNumberOrPhrase: string;
      SearchCriteria: string;
      MatchTo: number;
      CountryISOCode: string;
      OrganizationId: number;
    } = {
      SearcByNumberOrPhrase:
        this.phoneNumberPurchaseForm.value?.SearcByNumberOrPhrase,
      SearchCriteria: this.phoneNumberPurchaseForm.value?.SearchCriteria?.name,
      CountryISOCode:
        this.phoneNumberPurchaseForm.value?.selectedCountry?.isoCountryCode,
      OrganizationId: this.app.companyId,
      MatchTo: this.phoneNumberPurchaseForm.value?.MatchTo?.id,
    };
    // console.log(requestBody);

    this.botsService.searchNumber(requestBody).subscribe({
      next: (data: any) => {
        if (data?.length > 0) {
          this.allNumbers = data;
        }
        isShowLoader && this.appMainService.isHideSpinner('searchNumber');
      },
      error: (error: HttpErrorResponse) => {
        isShowLoader && this.appMainService.isHideSpinner('searchNumber');
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
  }

  buyPhoneNumber(product: any, isShowLoader = true) {
    isShowLoader && this.appMainService.isShowSpinner('buyPhoneNumber');
    let requestBody: {
      PhoneNumber: string;
      CountryISOCode: string;
      OrganizationId: number;
    } = {
      PhoneNumber: encodeURIComponent(product?.phoneNumber),
      CountryISOCode: product?.isoCountry,
      OrganizationId: this.app.companyId,
    };
    this.botsService.buyPhoneNumber(requestBody).subscribe({
      next: (data: any) => {
        if (data) {
          this.getActiveNumbers();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Phone no successfully...',
          });
          this.displayBuyNumber = false;
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'failed',
            detail: 'Soory failed...',
          });
        }
        isShowLoader && this.appMainService.isHideSpinner('buyPhoneNumber');
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
  }

  clear() {
    this.phoneNumberPurchaseForm.reset();
    this.allNumbers = [];
  }

  deactivateSubAccount(c, isShowLoader = true) {
    isShowLoader && this.appMainService.isShowSpinner('deactivateSubAccount');
    this.botsService.deactivateSubAccount(this.app.companyId).subscribe({
      next: (data) => {
        this.registeredData['statusId'] = 0;
        this.isSMSshowInstall = true;
        this.isSMSshowInstalled = false;
        this.isSMSshowDetail = false;
        c.showInstalled = false;
        c.showInstall = true;
        c.showDetail = false;
        isShowLoader &&
          this.appMainService.isHideSpinner('deactivateSubAccount');
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
  }

  activateSubAccount(c, isShowLoader = true) {
    isShowLoader && this.appMainService.isShowSpinner('activateSubAccount');
    this.botsService.activateSubAccount(this.app.companyId).subscribe({
      next: (data) => {
        this.registeredData['statusId'] = 1;
        this.isSMSshowInstalled = true;
        this.isSMSshowDetail = true;
        this.isSMSshowInstall = false;

        c.showInstalled = true;
        c.showInstall = false;
        c.showDetail = true;
        isShowLoader && this.appMainService.isHideSpinner('activateSubAccount');
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...',
        });
      },
    });
  }

  //whatapp
  addPhone() {
    this.isView = false;
    this.displayAddPhone = true;
  }

  cancelAdd() {
    this.displayAddPhone = false;
  }

  onRowSelect(e) {
    this.isView = true;
    this.displayAddPhone = true;
  }

  //registration
  openRegistration() {
    this.displayRegistration = true;
  }

  cancelRegistration() {
    this.displayRegistration = false;
  }
}
